export default __webpack_public_path__ + "static/media/section3-bg.5ab7938b.png";